import { jsx as _jsx } from "react/jsx-runtime";
import { useIsReviewer } from '../../hooks/useIsReviewer';
export const ReporterSection = (props)=>{
    const isReviewer = useIsReviewer();
    if (isReviewer) {
        return null;
    }
    return /*#__PURE__*/ _jsx("div", {
        className: "reporter-section",
        ...props
    });
};
